import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { MatDatepicker, MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { debounceTime, distinctUntilChanged, filter } from 'rxjs'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: 'passengers-import-excel',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSpinner,
    MatDividerModule
  ],
  templateUrl: './passengers-import-excel.component.html',
  styleUrl: './passengers-import-excel.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class PassagersImportExcelComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PassagersImportExcelComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading: boolean = false;

  documentMask: string = '';
  cellphoneMask: string = '(00) 00000-0000';

  page: number = 1;
  rows: number = 10;
  numberRows: number = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;
  allowedTypes = []
  file: File | null = null


  ngOnInit(): void {
    this.createForm()

  }

  checkDocAvailability(doc: string) {
    this.passangerService.searchPassengerByDocument(doc).subscribe({
      next: (res) => {
        console.log("Documento já encontrado: ", res)
      },
      error: (err) => {
        console.error('Erro ao buscar passageiros', err);
      }
    })
  }

  createFile() {
    if (!this.file) {
      console.error('Nenhum arquivo selecionado');
      return;
    }

    this.loading = true;
    const formData = this.createModelExcel();

    this.passangerOs.excelUploadPassengerOs(formData).subscribe({
      next: (res) => {
        this.snackbar.success('Passageiros importados com sucesso');
        this.closeModal()
        this.response.emit({ action: 'create', item: res });

      },
      error: (err) => {
        this.snackbar.errorRequest('Error ao fazer importação de passageiros');
        this.loading = false;
      },
      complete: () => {
        this.resetForm();

      }
    });
  }

  createModelExcel(): FormData {
    const formData = new FormData();
    formData.append('ExcelFile', this.file!, this.file!.name);
    formData.append('OsId', this.data.idOs);
    return formData;
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      // nomePassageiro: ['', [Validators.required]],
      // tipoDocumento: [''],
      // numeroDoc: [''],
      // contato: [''],
      // horaChegada: [''],
      // horaSaida: [''],
      // voo: [''],
      // companhia: [''],
      file: ['', [Validators.required]],
    });
  }



  closeModal() {
    this.dialogRef.close();
  }



  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
    this.form.valid
  }

  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }


  treatResponse(response: any) {
    let list = []
    console.log(response.data)
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }


  cancel() {
    this.editIndex = null;
    this.response.emit({ action: 'cancel' });
    this.resetForm();
  }

  resetForm() {
    this.form.reset();
  }
}
